import { type AppState } from '../../../types';

export const getFastFormSubmitAction = (state: AppState) => state.fastFormSubmit;
